/**
 * Single source of truth for the client-side password policy.
 *
 * Every password input (signup, reset, profile, change-password modal) validates
 * against these rules, so the "special character" set only has to be maintained here.
 */

// Every printable ASCII punctuation character plus the space, followed by the
// symbols reachable on a German keyboard layout (§ ° ´ € µ).
export const PASSWORD_SPECIAL_CHARACTERS = ' `~!@#$%^&*()-_=+[]{}\\|;:\'",.<>/?§°´€µ';

// `\`, `]`, `^` and `-` are the only characters that need escaping inside a character class.
const escapeForCharacterClass = (characters) => characters.replace(/[\\\]^-]/g, '\\$&');

export const passwordSpecialCharacterRegex = new RegExp(`[${escapeForCharacterClass(PASSWORD_SPECIAL_CHARACTERS)}]`);

// Requirements for the password validation
export const passwordRequirements = [
  { regex: /[A-Z]/, label: 'Mindestens einen Großbuchstaben haben' },
  { regex: /[a-z]/, label: 'Mindestens einen Kleinbuchstaben haben' },
  { regex: /[0-9]/, label: 'Eine Nummer haben' },
  { regex: passwordSpecialCharacterRegex, label: 'Ein Sonderzeichen enthalten (z. B. %, &, #, ~, ], })' },
  { regex: /.{8,}/, label: 'Mindestens 8 Zeichen lang sein' }
];

// Show password strength
export const getPasswordStrength = (password) => {
  let multiplier = password.length > 5 ? 0 : 1;

  passwordRequirements.forEach((requirement) => {
    if (!requirement.regex.test(password)) {
      multiplier += 1;
    }
  });

  return Math.max(100 - (100 / (passwordRequirements.length + 1)) * multiplier, 10);
};

// True when the password satisfies every requirement above.
export const isPasswordValid = (password) =>
  !!password && passwordRequirements.every((requirement) => requirement.regex.test(password));
